


















































































































































































































































import AfterFetchComponent from "@/components/base/AfterFetchComponent";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import i18n from "@/lang/lang";
import {KeyValuePair} from "@payroll/optimus-common";
import Component from 'vue-class-component'
import {Prop, Watch} from "vue-property-decorator";
import {Action} from "vuex-class";

@Component({
  components: {}
})
export default class EditDocumentsComponents extends AfterFetchComponent {

  @Prop(Number) memberProcessId!: number;
  @Prop(String) processType!: string;
  @Prop(Object) personalDetails!: any;
  @Prop(Object) loanStatusType!: any;
  @Prop(Boolean) isCompanyDocumentsEditable!: any;
  @Prop(Boolean) isEditableStatus!: any;


  @Action('getMemberProcessAttachment', StoreNamespace.PROCESSES) getMemberProcessAttachment: any;
  @Action('getAttachedFiles', StoreNamespace.PROCESSES) getAttachedFiles: any;
  @Action('updateAttachedFiles', StoreNamespace.PROCESSES) updateAttachedFile: any;
  //todo:
  @Action('updateLoanProcessPdf', StoreNamespace.PROCESSES) updateLoanProcessPdf: any;
  @Action('createOrUpdateCompanyDocuments', StoreNamespace.PROCESSES) createOrUpdateCompanyDocuments: any;
  @Action('optionalMemberLoanAttachment', StoreNamespace.PROCESSES) optionalMemberLoanAttachment: any;

  private attachedFiles: any = {
    fileId: [],
    fileName: [],
    fileData: [],
    fileMimeType: [],
    filesArray: [],
    filesToUpdate: []
  };
  private optionalAttachedFiles: any = {
    fileId: [],
    fileName: [],
    fileData: [],
    fileMimeType: [],
    filesArray: [],
    filesToUpdate: [],
    filesToUpdateIsUpdated: []
  };
  private optionalAttachedFileToAdd: any = {};
  private companyDocuments: any = {
    fileId: [],
    fileName: [],
    fileData: [],
    fileMimeType: [],
    filesArray: [],
    filesToUpdate: []
  };
  private countValidCompanyDocuments: number = 0;
  private companyFilesUpdated: any = [];
  private attachedFileUrl: any = '';
  private currentFileId: string = "";
  private fileName: string = "";
  private selected: string = "first";
  private options: any = [
    {text: 'מסמכים שצורפו בתהליך', value: 'first'},
    {text: 'מסמכים לשימוש פנימי', value: 'second'},
    {text: 'הוספת מסמך', value: 'third'}
  ];
  private loansAttachedFiles = [
    "additionalIdCard",
    "other"
  ]
  private loansBoAttachedFiles = [
    "creditIndicationReportFormBO"
  ]
  private showThirdSection: boolean = true;
  private showLoadingSaveDocuments = false;


  onSuccess(data: any, requestName?: string, message?: string) {
    switch (requestName) {

      case 'getMemberProcessAttachment':
        if (data.creditIndicationReportFormBO) {
          if (data.creditIndicationReportFormBO == "creditIndicationReportFormId-null") {
            data.creditIndicationReportFormBO = null;
          }
        }
        this.editDocumentsInit(data);
        break

      case 'getAttachedFiles' :
        this.updateFilesUrl(data)
        this.showLoadingSaveDocuments = false;
        break

      case 'updateAttachedFiles' :
        this.updatePdfDocuments()
        break;

      case 'updateLoanProcessPdf' :
        this.afterSaveDocuments()
        this.$emit('afterMemberPdfUpdated')
        break;

      case 'createOrUpdateCompanyDocuments':
        this.afterSaveDocuments()
        break;

      case 'optionalMemberLoanAttachment':
        this.updatePdfDocuments()
        break;
    }
  }

  onError(messages: string[], code: number, requestName?: string) {
    switch (requestName) {

      case 'updateAttachedFiles' :
      case 'updateLoanProcessPdf' :
      case 'createOrUpdateCompanyDocuments':
      case 'optionalMemberLoanAttachment':
        this.showLoadingSaveDocuments = false
        this.showErrorAlertNotification()
        break;
      default:
        this.handleOnError(messages, code, requestName);
    }
  }

  mounted() {
    if (this.memberProcessId) {
      this.closeEditDocumentPopup()
      this.onEditClick()
    }
  }

  @Watch('memberProcessId')
  onMemberProcessIdChanged() {
    if (this.memberProcessId && this.memberProcessId > 0) {
      this.closeEditDocumentPopup();
      this.onEditClick()
    }
  }

  editDocumentsInit(processAttachments: any) {
    const attachmentsModel = processAttachments;
    let idList = [];

    for (let attachmentsModelElement in attachmentsModel) {
      if (attachmentsModel[attachmentsModelElement]
          && this.isMemberAttachment(attachmentsModelElement)
          && attachmentsModelElement !== 'signature') {
        this.attachedFiles.fileName.push(attachmentsModelElement);
        this.attachedFiles.fileId.push(attachmentsModel[attachmentsModelElement]);
        this.attachedFiles.filesArray.push([]);
        this.attachedFiles.filesToUpdate.push([]);
      } else if (this.isMemberAttachment(attachmentsModelElement) && this.checkIfAttachedFileBelongToLoans(attachmentsModelElement)) {
        this.optionalAttachedFiles.fileName.push(attachmentsModelElement)
        this.optionalAttachedFiles.filesArray.push([]);
        this.optionalAttachedFiles.filesToUpdate.push([]);
        this.optionalAttachedFiles.filesToUpdateIsUpdated.push(false);
        this.optionalAttachedFiles.fileId.push('');
      }

      if (!this.isMemberAttachment(attachmentsModelElement)) {

        if (this.checkIfProcessTypeNotBelongToLoans() && this.checkIfAttachedFileBelongToLoansBackOffice(attachmentsModelElement)) {
          continue;
        }

        this.companyDocuments.fileName.push(attachmentsModelElement);
        this.companyDocuments.filesArray.push([]);
        this.companyDocuments.filesToUpdate.push([]);
        if (attachmentsModel[attachmentsModelElement]) {
          this.companyDocuments.fileId.push(attachmentsModel[attachmentsModelElement]);
          idList.push(attachmentsModel[attachmentsModelElement])
          this.countValidCompanyDocuments++;
          this.companyFilesUpdated.push(attachmentsModelElement)

        } else {
          this.companyDocuments.fileId.push('');
        }
      }
    }

    idList.push(...this.attachedFiles.fileId);

    this.currentFileId = this.attachedFiles.fileId[0];
    this.getAttachedFiles({
      requestorCallback: this,
      requestBody: idList
    })
  }

  private checkIfProcessTypeNotBelongToLoans() {
    return this.processType !== 'LOAN_RECYCLE' && this.processType !== 'LOAN_PROCESS';
  }

  private isMemberAttachment(attachmentsModelElement: string) {
    let attachmentTypes = attachmentsModelElement !== 'otherBO' &&
        attachmentsModelElement !== 'rakefetAlertCheckBO' && attachmentsModelElement !== 'creditIndicationReportFormBO';

    if (this.processType === 'LOAN_RECYCLE' || this.processType === 'LOAN_PROCESS') {
      attachmentTypes = attachmentTypes && attachmentsModelElement !== 'loanAccountAlertBO';
    }

    return attachmentTypes
  }

  closeEditDocumentPopup() {
    this.attachedFileUrl = ''
    this.countValidCompanyDocuments = 0;
    this.companyFilesUpdated = [];
    this.selected = "first";
    this.attachedFiles = {
      fileId: [],
      fileName: [],
      fileData: [],
      fileMimeType: [],
      filesArray: [],
      filesToUpdate: []
    }

    this.companyDocuments = {
      fileId: [],
      fileName: [],
      fileData: [],
      fileMimeType: [],
      filesArray: [],
      filesToUpdate: []
    }

    this.optionalAttachedFiles = {
      fileId: [],
      fileName: [],
      fileData: [],
      fileMimeType: [],
      filesArray: [],
      filesToUpdate: [],
      filesToUpdateIsUpdated: []
    };
  }

  base64ToArrayBuffer(data: string) {
    let bString = window.atob(data);
    let bLength = bString.length;
    let bytes = new Uint8Array(bLength);
    for (let i = 0; i < bLength; i++) {
      let ascii = bString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  updateFilesUrl(data: any) {
    let index = 0;

    for (let element of data) {
      if (index < this.countValidCompanyDocuments) {
        let indexToUpdate = this.companyDocuments.fileName.indexOf(this.companyFilesUpdated[index])
        this.companyDocuments.fileMimeType[indexToUpdate] = element.mimeType;
        this.companyDocuments.fileData[indexToUpdate] = element.file;
        index++;
      } else {
        this.attachedFiles.fileMimeType.push(element.mimeType);
        this.attachedFiles.fileData.push(element.file)
      }
    }
  }

  onMemberAttachmentFileUpdated(files: any, index: number) {
    this.attachedFiles.filesToUpdate[index] = files[0].file
    this.attachedFiles.fileMimeType[index] = files[0].type
  }

  onOptionalMemberAttachmentFileUpdated(files: any, index: number) {
    this.showThirdSection = false;
    this.optionalAttachedFiles.filesToUpdate[index] = files[0].file
    this.optionalAttachedFiles.fileMimeType[index] = files[0].type
    this.optionalAttachedFiles.filesToUpdateIsUpdated[index] = true
    this.showThirdSection = true;
  }

  onCompanyFileUpdated(files: any, index: number) {
    this.companyDocuments.filesToUpdate[index] = files[0].file
    this.companyDocuments.fileMimeType[index] = files[0].type
  }

  onMemberAttachmentRemovedClicked(index: number) {
    this.attachedFiles.filesToUpdate[index] = []
    this.attachedFiles.fileMimeType[index] = ""
  }

  onOptionalMemberAttachmentRemovedClicked(index: number) {
    this.optionalAttachedFiles.filesToUpdate[index] = []
    this.optionalAttachedFiles.fileMimeType[index] = ""

    this.optionalAttachedFiles.filesToUpdateIsUpdated[index] = false
  }

  onCompanyFileRemovedClicked(index: number) {
    this.companyDocuments.filesToUpdate[index] = []
    this.companyDocuments.fileMimeType[index] = ""
  }

  saveUpdates() {


    let isFilesUpdated: boolean = false;
    const files = this.attachedFiles.filesToUpdate;
    let formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      if (files[i] instanceof File) {

        formData.append('files', files[i])
        formData.append('idList', this.attachedFiles.fileId[i]);

        isFilesUpdated = true
        this.showLoadingSaveDocuments = true;
      }
    }

    if (isFilesUpdated) {
      this.updateAttachedFile({
        requestorCallback: this,
        requestBody: formData
      });
    }

    let isCompanyFilesUpdated: boolean = false;
    const companyFiles = this.companyDocuments.filesToUpdate;
    const formDataCompanyDocument: FormData = new FormData();
    for (let i = 0; i < companyFiles.length; i++) {
      if (companyFiles[i] instanceof File) {
        formDataCompanyDocument.append('files', companyFiles[i])
        formDataCompanyDocument.append('idList', this.companyDocuments.fileId[i]);
        formDataCompanyDocument.append('memberProcessIdList', this.memberProcessId + '')
        formDataCompanyDocument.append('managingCompanyDocumentsNames', this.companyDocuments.fileName[i])

        isCompanyFilesUpdated = true;
        this.showLoadingSaveDocuments = true;
      }
    }

    if (isCompanyFilesUpdated) {
      this.createOrUpdateCompanyDocuments({
        requestorCallback: this,
        requestBody: formDataCompanyDocument
      });
    }
  }

  private updatePdfDocuments() {
    this.updateLoanProcessPdf({
      requestorCallback: this,
      pathVariable: this.memberProcessId
    })
  }

  fetchAttachedFile(index: number, fileName: string) {
    if (this.isMemberAttachment(fileName.toString().split('.')[2])) {
      let bufferArray = this.base64ToArrayBuffer(this.attachedFiles.fileData[index]);
      let blobStore = new Blob([bufferArray], {type: this.attachedFiles.fileMimeType[index]});
      this.attachedFileUrl = window.URL.createObjectURL(blobStore);
      this.fileName = fileName;
    } else {
      if (this.companyDocuments.fileData[index]) {
        let bufferArray = this.base64ToArrayBuffer(this.companyDocuments.fileData[index]);
        let blobStore = new Blob([bufferArray], {type: this.companyDocuments.fileMimeType[index]});
        this.attachedFileUrl = window.URL.createObjectURL(blobStore);
        this.fileName = fileName;
      } else {
        this.attachedFileUrl = '';
      }
    }
  }

  onEditClick() {
    let formData: FormData = new FormData()

    formData.append('processTypeCode', this.processType)
    formData.append('memberProcessId', this.memberProcessId.toString())

    this.getMemberProcessAttachment({
      requestorCallback: this,
      formData: formData
    })
  }

  private afterSaveDocuments() {

    this.showAlertNotification()


    this.attachedFileUrl = ''
    this.countValidCompanyDocuments = 0;
    this.companyFilesUpdated = [];
    this.selected = "first";
    this.attachedFiles = {
      fileId: [],
      fileName: [],
      fileData: [],
      fileMimeType: [],
      filesArray: [],
      filesToUpdate: []
    }

    this.companyDocuments = {
      fileId: [],
      fileName: [],
      fileData: [],
      fileMimeType: [],
      filesArray: [],
      filesToUpdate: []
    }

    this.optionalAttachedFiles = {
      fileId: [],
      fileName: [],
      fileData: [],
      fileMimeType: [],
      filesArray: [],
      filesToUpdate: [],
      filesToUpdateIsUpdated: []
    };


    this.onEditClick()
  }

  private checkIfAttachedFileBelongToLoans(fileName: string) {
    return this.loansAttachedFiles.includes(fileName);
  }

  private checkIfAttachedFileBelongToLoansBackOffice(fileName: string) {
    return this.loansBoAttachedFiles.includes(fileName);
  }

  private onAddAttachmentClick(index: number, fileName: string) {
    this.showLoadingSaveDocuments = true;

    const formData: FormData = new FormData();
    formData.append("file", this.optionalAttachedFiles.filesToUpdate[index])
    formData.append("memberProcessId", this.memberProcessId + '')
    formData.append("optionalAttachmentName", fileName)


    this.optionalMemberLoanAttachment({
      requestorCallback: this,
      requestBody: formData
    });
  }

  onRadioButtonSelectionChanged(selected: any) {
    this.attachedFileUrl = ''
  }

  private showAlertNotification() {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: 'requestManagement.popup.loanRequestUpdatedSuccessfully',
      icon: 'checkCircle',
      secondsToDisappear: 3
    })
  }

  private showErrorAlertNotification() {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: 'requestManagement.popup.loanRequestUpdatedFailed',
      icon: 'warning',
      secondsToDisappear: 3
    })
  }

  private getOptionalAttachedFiles() {
    let files: KeyValuePair[] = [];

    let index = 0;
    this.optionalAttachedFiles.fileName.forEach((fileName: any) => {
      const translatedFileName: string = i18n.t('requestManagement.popup.' + fileName).toString()
      files.push({value: index.toString(), description: translatedFileName});
      index++
    });

    return files;
  }


};


